import { jsxs as C, jsx as V } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as e } from "./index.es2359.js";
function l({ size: H = e }) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: H,
      height: H,
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ V("rect", { y: "0.468262", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ V(
          "path",
          {
            d: "M28.3692 17.0991L32 21.0742V25.4683H39.0066C39.2827 25.4683 39.5066 25.6921 39.5066 25.9683V38.9683C39.5066 39.5205 39.0589 39.9683 38.5066 39.9683H17.5066C16.9543 39.9683 16.5066 39.5205 16.5066 38.9683V25.9683C16.5066 25.6921 16.7304 25.4683 17.0066 25.4683H24V21.0742L27.6308 17.0991C27.8291 16.882 28.1709 16.882 28.3692 17.0991Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ V(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M30.2288 19.135L32 21.0742V25.8015H24V21.0742L25.7712 19.135H20.0746L16.5334 25.8017H39.4668L35.9256 19.135H30.2288ZM20 30.3015C20 30.0254 20.2239 29.8015 20.5 29.8015H24.8333C25.1095 29.8015 25.3333 30.0254 25.3333 30.3015V40.4682H20V30.3015Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ V(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M27.2616 16.7619C27.6582 16.3277 28.3418 16.3277 28.7384 16.7619L30.4492 18.635H35.9256C36.1106 18.635 36.2804 18.7371 36.3672 18.9005L39.794 25.3519C39.9272 25.5217 40.0066 25.7358 40.0066 25.9684V38.9684C40.0066 39.7968 39.335 40.4684 38.5066 40.4684H17.5066C16.6782 40.4684 16.0066 39.7968 16.0066 38.9684V25.9684C16.0066 25.8703 16.0207 25.7756 16.047 25.6861C16.055 25.6523 16.0666 25.619 16.0819 25.587C16.1059 25.5289 16.1352 25.4735 16.1692 25.4215L19.6331 18.9005C19.7198 18.7371 19.8897 18.635 20.0746 18.635H25.5508L27.2616 16.7619ZM17.0066 26.3017V38.9684C17.0066 39.2445 17.2304 39.4684 17.5066 39.4684H20V30.3015C20 30.0254 20.2239 29.8015 20.5 29.8015H24.8333C25.1095 29.8015 25.3333 30.0254 25.3333 30.3015V39.4684H38.5066C38.7827 39.4684 39.0066 39.2445 39.0066 38.9684V26.3017H17.0066ZM32.5 20.8803L31.3626 19.635H35.625L38.635 25.3017H32.5V20.8803ZM23.5 20.8803V25.3017H17.3652L20.3752 19.635H24.6374L23.5 20.8803ZM28 17.4363L24.5 21.2682V25.3015H31.5V21.2682L28 17.4363ZM21 39.4682V30.8015H24.3333V39.4682H21ZM27.6667 30.8015V32.635H29.6667V30.8015H27.6667ZM26.6667 32.635V33.635V36.4682H30.6667V33.635V32.635V30.3015C30.6667 30.0254 30.4429 29.8015 30.1667 29.8015H27.1667C26.8906 29.8015 26.6667 30.0254 26.6667 30.3015V32.635ZM29.6667 35.4682V33.635H27.6667V35.4682H29.6667ZM33 30.8015V32.635H35V30.8015H33ZM32 32.635V33.635V36.4682H36V33.635V32.635V30.3015C36 30.0254 35.7761 29.8015 35.5 29.8015H32.5C32.2239 29.8015 32 30.0254 32 30.3015V32.635ZM35 35.4682V33.635H33V35.4682H35Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
l.__tags = [];
export {
  l as MetricHouseIcon
};
//# sourceMappingURL=index.es394.js.map
